import { lazy } from 'react';
import i18next from 'i18next';
import permissions from '@shared/config/permissions';
import { ResourcesIcon } from '@shared/ui/icons';

const Resources = lazy(() => import('@pages/resources'));

// const RESOURCE_ROUTE_LIST_DS = {
//   path: '/:currentAccountUuid/accounts/:accountUuid/resources',
//   exact: true,
//   additional: {
//     component: Resources,
//     protected: true,
//     title: i18next.t('titles:resources'),
//     icon: AllergiEndResourcesLogo,
//     permission: permissions.GET_RESOURCES,
//   },
// };

const RESOURCE_ROUTE_LIST = {
  path: '/:currentAccountUuid/resources',
  exact: true,
  additional: {
    component: Resources,
    protected: true,
    title: i18next.t('titles:resources'),
    icon: ResourcesIcon,
    permission: permissions.GET_RESOURCES,
    breadcrumb: {
      isRoot: true,
      label: ({ state }) => state.i18n?.en?.titles?.resources || 'Resources',
    },
  },
};

export const RESOURCE_ROUTES = {
  // ------- For child accounts ------
  // listDS: RESOURCE_ROUTE_LIST_DS,

  // ------- For current accounts ------
  list: RESOURCE_ROUTE_LIST,
};
